import React from "react";
import Social from "../Social";
import Testimonials from "../testimonial/Testimonial";
import Services from "../service/Service";
import Awards from "../award/Awards";

const AboutTwo = () => {
  return (
    <>
      <section id="about" className="section theme-light dark-bg">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-6 col-lg-4">
              <div className="about-me">
                <div className="img">
                  <div className="img-in">
                    <img src="img/about/about-me-2.jpg" alt="about" />
                  </div>
                  <Social />
                  {/* End social icon */}
                </div>
                {/* End img */}
                <div className="info">
                  <p>EdCodeHead</p>
                  <h3>Ed Banks</h3>
                </div>
                {/* End info */}
              </div>
              {/* End about-me */}
            </div>
            {/* End col */}

            <div className="col-lg-7 ml-auto">
              <div className="about-info">
                <div className="title">
                  <h3>About Me</h3>
                </div>
                <div className="about-text">
                  <p>
                    FOCUS. DETERMINATION. DRIVE.
                  </p>
                  <p>
                  Business minded, creative, tech savvy professional with over 10 years experience helping 
                  small business owners and startups market themselves online. Passionate about learning and contributing to the 
                  success of a team. Thrives on creating beautiful and interactive user interfaces. 
                  Very organized and excellent in learning new technologies quickly. Military veteran with an 
                  internal drive to push himself for a greater good.
                  </p>
                </div>
                <div className="info-list">
                  <div className="row">
                    {/* <div className="col-sm-6">
                      <ul>
                        <li>
                          <label>Name: </label>
                          <span>Ed Hart</span>
                        </li>
                        <li>
                          <label>Hometown: </label>
                          <span>Phoenix, AZ</span>
                        </li>
                        <li>
                          <label>Age: </label>
                          <span>40 years old</span>
                        </li>
                        <li>
                          <label>Address: </label>
                          <span>San Francisco</span>
                        </li>
                      </ul>
                    </div> */}
                    <div className="col-sm-6">
                      <ul>
                        <li>
                          <label>Phone: </label>
                          <span>(602) 753-8429</span>
                        </li>
                        <li>
                          <label>Email: </label>
                          <span>edcodehead@gmail.com</span>
                        </li>
                        <li>
                          <label>LinkedIn: </label>
                          <a href="https://www.linkedin.com/in/edcodehead/"><span>edcodehead</span></a>
                        </li>
                        <li>
                          <label>Freelance: </label>
                          <span>Available</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End col */}
          </div>

          {/* separated */}
          <div
            className="separated"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + "img/border-dark.png"
              })`,
            }}
          ></div>
          {/* End separated */}
          <div className="title">
            <h3>What I do?</h3>
          </div>
          <Services />
          {/* End .row */}

          {/* separated */}
          <div
            className="separated"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + "img/border-dark.png"
              })`,
            }}
          ></div>
          {/* End separated */}

          {/* <div className="title">
            <h3>Awards.</h3>
          </div>
          <Awards /> */}
          {/* End Awards */}

          {/* separated */}
          {/* <div
            className="separated"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + "img/border-dark.png"
              })`,
            }}
          ></div> */}
          {/* End separated */}

          <div className="title">
            <h3>Testimonials</h3>
          </div>
          <Testimonials />
          {/* End Testimonaial */}
        </div>
      </section>
    </>
  );
};

export default AboutTwo;
